<template>
  <main>
    <template v-if="!isConnected && downloadedEnrolls.length">
      <div class="section-title container">Disponível offline</div>
      <div class="gridCourses container">
        <div class="box-main" v-for="enroll in downloadedEnrolls" :key="enroll.id">
          <course-box :enroll="enroll"></course-box>
        </div>
      </div>
      <div v-if="otherEnrolls.length" class="section-title container">Outros cursos</div>
    </template>
    <div class="gridCourses container">
      <div class="box-main" v-for="enroll in isConnected ? enrolls : otherEnrolls" :key="enroll.id">
        <course-box :enroll="enroll"></course-box>
      </div>
    </div>
  </main>
</template>

<script>
import CourseBox from "@/components/MyCoursesCourseBox";
import { mapState, mapGetters } from "vuex";

export default {
  name: "MyCourses",
  components: {
    CourseBox
  },
  computed: {
    ...mapState({
      enrolls: state => state.enroll.enrolls
    }),
    ...mapGetters({
      isConnected: 'dom/isConnected',
      isStructureCached: 'download/isStructureCached'
    }),
    downloadedEnrolls() {
      return (this.enrolls || []).filter(e => this.isStructureCached(e.id));
    },
    otherEnrolls() {
      return (this.enrolls || []).filter(e => !this.isStructureCached(e.id));
    }
  },
  mounted() {
    this.$store.dispatch('enroll/clearCurrentEnroll');
    this.$updateTheme({
      darkTheme: false,
      primary: "#0564b1",
      secondary: "#ffffff"
    });
    this.$gtag.pageview({
      page_title: 'meus cursos',
      page_path: '/p/my-courses'
    });
  },
};
</script>

<style scoped lang="scss">
#app {
  header,
  header nav,
  main,
  footer {
    background-color: #fff !important;
  }

  nav i {
    color: #7f7f7f;
  }

  .menu-right-header {
    background-color: #f5f5f5;
  }

  .section-title {
    font-family: robotomedium;
    font-size: 16px;
    color: #717171;
    padding: 24px 16px 8px;
    width: 100%;
  }

  .gridCourses{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 30px;
  }

  .box-main{
    // border:1px solid red;

    width: 296px;
  height: 353px;
  margin: 17px 16px 0 2px;
  border-radius: 10px;
  box-shadow: 4px 4px 15px 0 rgba(0, 0, 0, 0.2);
  background-color: var(--main-surface-white);
  overflow: hidden;
  }


  @media only screen and (max-width: 992px) {

             .gridCourses{
               justify-content: center;
             }

             .box-main{
               margin: 0 0 20px 0 !important;
               height: 296px !important;
               // width: 100%  !important;
             }

             .course-info-top{
               padding: 10px 15px 0 15px !important;
             }
     }


}


</style>
